/**
 * useAudio hook - Provides access to the audio system
 */

import { useContext } from 'react';
import { AudioContext } from '../audio/AudioContext.jsx';

export function useAudio() {
  const context = useContext(AudioContext);

  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }

  return context;
}
